import axios from "axios";
import { useState } from "react";
import { resolvePath, useNavigate } from "react-router-dom";
import "./NewUSER.css";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { db } from "../../firebase";
import { collection, getDoc, getDocs } from "firebase/firestore";
import { addDoc } from "firebase/firestore";
import { doc, updateDoc } from "firebase/firestore";
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from "../../BASE_URL";
import Loader from "../../Components/Loader/Loader";

const Registration = () => {
  const [loading, setLoading] = useState(false)
  const [user_name, setuser_name] = useState("");
  const [contact_no, setcontact_no] = useState("");
  localStorage.setItem("contactnumber", contact_no);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  localStorage.setItem("password", password);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);

  const handlePhoneNumberChange = (e) => {
    const value = e.target.value;
    // Only allow numbers
    const numericValue = value.replace(/[^0-9]/g, '');
    
    // If it's the first digit, check if it's 6-9
    if (numericValue.length > 0) {
      const firstDigit = parseInt(numericValue[0]);
      if (firstDigit >= 6) {
        setcontact_no(numericValue);
      } else if (numericValue.length === 1) {
        toast.error('Phone number must start with 6-9', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 1000,
        });
      }
    } else {
      setcontact_no(numericValue);
    }
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
  };

  const handleSubmit = async () => {
    const data = {
      user_name: user_name,
      contact_no: "+91" + contact_no,
      email: email,
      password: password,
    };
    if (!user_name) {
      toast.error('Please Enter Your Name!', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!contact_no) {
      toast.error('Please Enter Mobile Number!', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (contact_no.length !== 10) {
      toast.error('Please Enter Valid Contact Number', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    // Validate first digit of phone number
    const firstDigit = parseInt(contact_no[0]);
    if (firstDigit < 6) {
      toast.error('Phone number must start with 6-9', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!email) {
      toast.error('Please Enter Email Address!', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Please Enter A Valid Email Address', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!password) {
      toast.error('Please Enter Password!', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    // Validate password length
    if (password.length < 6) {
      toast.error('Password must be at least 6 characters long', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (!confirmPassword) {
      toast.error('Please Enter Confirm Password As A Password!', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }
    if (password !== confirmPassword) {
      toast.error('Passwords And Confirm Password Do Not Match', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 1000,
      });
      return;
    }

    setLoading(true)

    try {
      const response = await axios.post(`${BASE_URL}/api/profile/send-otp`, {
        contact: contact_no,
        status: "register",
      });

      if (response.status === 200) {
        setLoading(false)
        localStorage.setItem('usernameForBio', user_name)
        navigate("/Otp", { state: { data: data } });
        localStorage.setItem('otpNumber', contact_no)
        toast.success('OTP sent successfully!', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
      } else {
        setLoading(false)
        toast.error('Failed to send OTP. Please try again.', {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
      }
    } catch (error) {
      setLoading(false)
      
      toast.error('Error sending OTP. Please check your network connection and try again.', {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
      });
    }
  };

  const formatName = (input) => {
    const nameParts = input.split(' ');
    const formattedNameParts = nameParts.map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase());
    return formattedNameParts.join(' ');
  };

  const handleInputChange = (e) => {
    const filteredValue = e.target.value.replace(/[0-9]/g, '');
    const formattedName = formatName(filteredValue);
    setuser_name(formattedName);
  };

  return (
    <div className="container">
      <div className="login__wrapepr reg_wrapper">
        <div className="login register_page login-padding">
          <h2>User Details</h2>
          <div className="class_for_label">
            <p className="mb-1">Enter Your Name</p>
            <input
              placeholder="Username"
              className=" rounded px-3 py-1"
              type="text"
              value={user_name}
              onChange={handleInputChange}
              required
              style={{ border: "1px solid #f97096", width: "100%" }}
            />
          </div>
          <div className="class_for_label">
            <p className="mb-1">Enter Your Mobile Number</p>
            <input
              placeholder="Mobile Number"
              type="tel"
              name="contact_no"
              className="rounded px-3 py-1"
              id="contact_no"
              maxLength="10"
              value={contact_no}
              onChange={handlePhoneNumberChange}
              required
              style={{
                border: "1px solid #f97096",
                backgroundColor: "transparent",
                width: "100%"
              }}
            />
          </div>
          <div className="class_for_label">
            <p className="mb-1">Enter Your Email</p>
            <input
              placeholder="Email"
              type="email"
              className=" rounded px-3 py-1"
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ border: "1px solid #f97096", width: "100%" }}
            />
          </div>
          <div className="class_for_label">
            <p className="mb-1">Enter Your Password</p>
            <div className="eye-password-confirm-relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                name="password"
                className=" rounded px-3 py-1"
                onChange={handlePasswordChange}
                required
                style={{ border: "1px solid #f97096", width: "100%" }}
              />
              <div className="eye-password-confirm">
                <FontAwesomeIcon
                  icon={showPassword ? faEyeSlash : faEye}
                  className="eye-icon"
                  onClick={() => setShowPassword(!showPassword)}
                />
              </div>
            </div>
          </div>
          <div className="class_for_label">
            <p className="mb-1">Confirm Password</p>
            <div className="eye-password-confirm1-relative">
              <input
                type={showPassword1 ? "text" : "password"}
                placeholder="Confirm Password"
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                className=" rounded px-3 py-1"
                style={{ border: "1px solid #f97096", width: "100%" }}
              />
              <div className="eye-password-confirm1">
                <FontAwesomeIcon
                  icon={showPassword1 ? faEyeSlash : faEye}
                  className="eye-icon"
                  onClick={() => setShowPassword1(!showPassword1)}
                />
              </div>
            </div>
          </div>
          <div id="recaptcha"><ToastContainer /></div>
          {loading ? (
            <button className="text-light">
              <Loader />
            </button>
          ) : (
            <button onClick={handleSubmit} className="text-light">
              Next
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Registration;

